import { RouterProvider, createRouter } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen";
import { Loader2 } from "lucide-react";

const router = createRouter({
  routeTree,
  defaultErrorComponent: ({ error }) => (
    <div role="alert" className="error-boundary">
      <h1>Error</h1>
      <pre>{error.message}</pre>
    </div>
  ),
});

// Type registration for TanStack Router
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

function App() {
  return (
    <RouterProvider
      router={router}
      // Provide fallback UI during route transitions
      defaultPendingComponent={() => (
        <div
          role="status"
          className="flex flex-col w-full items-center justify-center h-[100vh]"
          aria-label="Loading"
        >
          <Loader2 className="animate-spin size-10" />
        </div>
      )}
    />
  );
}

export default App;
